export default "__VITE_ASSET__ClTrBZaH__"